<template>
  <span
    class="mb-3 flex items-center gap-2 text-black"
    :class="{ 'font-semibold': !data?.status}"
  >
    <FontAwesomeIcon
      v-if="data?.status"
      :icon="faList"
    />
    Order Summary
  </span>

  <!-- Item(s) Summary -->
  <p class="items text-base mb-2 flex items-center justify-between">
    <span class="text-gray-dark">{{ data?.items?.length + (data?.items?.length === 1 ? ' item' : ' items') }}</span>

    <span>
      R{{ data?.subtotal?.toFixed((2)) }}
    </span>
  </p>

  <!-- Delivery Fee -->
  <h4
    v-if="data?.deliveryFee"
    class="delivery-fee !text-base mb-2 flex items-center justify-between"
  >
    <span class="text-gray-dark">Delivery fee</span>

    <span>
      R{{ data?.deliveryFee?.toFixed(2) }}
    </span>
  </h4>

  <!-- Total -->
  <h3 class="total text-base m-0 flex items-center justify-between">
    <span class="font-medium text-black">{{ data?.status ? 'Total' : 'To Pay' }}</span>

    <span class="font-medium text-black">
      R{{ data?.totalCost?.toFixed(2) }}
    </span>
  </h3>

  <slot />
</template>

<script setup>
import { faList } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { useCartStore } from '@/store';

const props = defineProps({
  order: {
    type: Object,
    default: null,
  },
});

const cartStore = useCartStore();

const data = props.order || cartStore.cart;

</script>
